import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData, convertHtmlTag, convertTagStyle } from '@utils/tools';
import ScratchClass from '@utils/scratch';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './Scratch.less';

export default class Scratch extends OfficialPage {
  state = {
    topNavBarData: {
      title: '刮刮乐',
      isDefault: 0
    },
    isShowBtn: false, //点我刮奖显示与隐藏
    scratchInfo: {}, //获取活动信息
    scratchTimes: '', //剩余次数
    scratchId: '', //活动号
    winnerList: [], //获奖名单信息
    isPrizeSick: false, //中奖纪录弹窗显示与隐藏
    isIntel: false, //兑奖次数弹窗显示
    myPrize: [], //中奖记录
    intelMes: {}, //兑换信息
    inputValue: '', //兑换次数
    isFail: true, //显示未中奖
    isPrize: true, //显示中奖
    isComfort: true, //显示安慰奖
    hideCanvas: false,
    isDegree: false,
    isDurMax: false,
    scratchPrizeTitle: '', //中奖名称
    animationData: {},
    animationData2: {},
    isScroll: true, //刮刮乐当在 canvas 中移动时且有绑定手势事件时禁止屏幕滚动以及下拉刷新
    isPlay: false,
    isLimit: false,
    time_limit: '',
    isRoll: true,
    scratchStatus: '',
    franchisee: '',
    ifWxCoupon: false,
    timestamp: '',
    signature: '',
    ifGetComfort: false
  }

  constructor(props) {
    super(props);
    document.title = '刮刮乐';
  }

  componentDidMount(options = getCurrentPageQueryParams()) {
    let that = this
    let franchisee = options.franchisee || ''
    let systemInfo = app.globalData.systemInfo
    let width = (558 * systemInfo.windowWidth) / 750
    let height = (258 * systemInfo.windowWidth) / 750
    that.setData({
      franchisee: franchisee,
      shareKey: options.shareKey || ''
    })
    that.scratch = new ScratchClass(that, {
      canvasWidth: width,
      canvasHeight: height,
      imageResource:
        app.getSiteBaseUrl() +
        '/index.php?r=Download/DownloadResourceFromUrl&url=https://chn.jisuapp.cn/zhichi_frontend/static/webapp/images/scratchMovie.png',
      maskColor: 'red',
      r: 18,
      callback: () => {
        that.setData({
          hideCanvas: true
        })
        if (that.data.ifWxCoupon) {
          setTimeout(function() {
            that.toAddCard()
          }, 500)
        }
      },
      imgLoadCallback: () => {
        setTimeout(function() {
          that.setData({
            isShowBtn: true
          })
        }, 10)
      }
    })
    if (app.isLogin()) {
      that.getScratchData()
    } else {
      app.goLogin({
        success: function () {
          that.getScratchData()
        },
        fail: function () {
          app.turnBack()
        }
      })
    }
    this.animation = app.createAnimation({
      duration: 0,
      timingFunction: 'step-start'
    })
    this.animation2 = app.createAnimation({
      duration: 0,
      timingFunction: 'step-start'
    })
  }

  componentWillUnmount() {
    let that = this
    clearTimeout(that.timeer)
    clearTimeout(that.timeer2)
    clearTimeout(that.timeer3)
    clearTimeout(that.timeer4)
  }

  getShareKey = id => {
    var that = this,
      dataObj = new Object()
    dataObj['activity_id'] = id
    if (that.data.franchisee) {
      dataObj['sub_app_id'] = that.data.franchisee
    }
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getShareKey',
      data: dataObj,
      success: function (res) {
        var data = res
        if (data.status == 0) {
          that.setData({
            shareKey: data.data
          })
        }
      }
    })
  }
  getTimeByShareKey = (id, shareKey) => {
    var that = this,
      dataObj = new Object()
    dataObj['activity_id'] = id
    dataObj['share_key'] = shareKey
    if (that.data.franchisee) {
      dataObj['sub_app_id'] = that.data.franchisee
    }
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getTimeByShareKey',
      data: dataObj,
      success: function (res) { }
    })
  }
  startScratch = () => {
    let that = this
    if (!that.data.scratchId) {
      return
    }
    if (that.data.time_limit == 0) {
      that.setData({
        isLimit: true,
        hideCanvas: true,
        isShowBtn: false
      })
    } else {
      if (that.data.scratchTimes <= 0) {
        if (that.data.scratchInfo.time_share == 0) {
          that.setData({
            isDegree: true,
            hideCanvas: true,
            isShowBtn: false
          })
        } else {
          that.setData({
            isDurMax: true,
            hideCanvas: true,
            isShowBtn: false
          })
        }
      } else {
        if (that.scratchLoading) {
          return false
        }
        that.setData({
          isShowBtn: false
        })
        that.scratchLoading = true
        that.getLottery()
      }
    }
  }
  getScratchData = () => {
    let that = this,
      dataObj = new Object()
    dataObj['category'] = 3
    if (that.data.franchisee) {
      dataObj['sub_app_id'] = that.data.franchisee
    }
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getActivity',
      method: 'post',
      data: dataObj,
      success: function (res) {
        let mes = res.data
        mes.description = mes.description.replace(/\\n/g, '\n')
        that.setData({
          scratchInfo: mes,
          scratchTimes: mes.times,
          scratchId: mes.id,
          time_limit: mes.time_limit
        })
        app.setNavigationBarTitle({
          title: mes.title
        })
        // TODO
        // that.audioCtx = app.createAudioContext('scratchAudio')
        // if (mes.bgm != 0) {
        //   that.audioCtx.play()
        // } else {
        //   that.audioCtx.pause()
        // }
        that.getWinnerList(mes.id)
        if (that.data.shareKey) {
          that.getTimeByShareKey(mes.id, that.data.shareKey)
        }
        that.getShareKey(that.data.scratchId)
      }
    })
  }
  scratchLoading = false
  getLottery = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/lottery',
      method: 'post',
      hideLoading: true,
      data: {
        activity_id: that.data.scratchId,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        let data = res.data,
          newData = {}
        that.scratch.start()
        if (data.title == '谢谢参与') {
          newData = {}
          newData['isFail'] = false
          newData['scratchTimes'] = data.time
          newData['time_limit'] = data.time_limit
          that.setData(newData)
        } else {
          newData = {}
          if (data.is_comfort == 1) {
            newData['isComfort'] = false
          } else {
            newData['isPrize'] = false
            newData['scratchPrizeTitle'] = data.title
          }
          let ifWxCoupon = data.card_id || false
          newData['ifWxCoupon'] = ifWxCoupon
          newData['timestamp'] = data.timestamp || ''
          newData['signature'] = data.signature || ''
          newData['scratchTimes'] = data.time
          newData['time_limit'] = data.time_limit
          that.setData(newData)
          that.getWinnerList(that.data.scratchId)
        }
        that.scratchLoading = false
      },
      successStatusAbnormal: function (res) {
        that.scratchLoading = false
        if (res.status == 1) {
          that.setData({
            isShowBtn: true
          })
        }
      }
    })
  }
  getWinnerList = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getWinnerList',
      method: 'post',
      hideLoading: true,
      data: {
        activity_id: id,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        let winHeight = (res.count + 5) * 44
        that.setData({
          winnerList: res.data
        })
        that.animationTop(winHeight, true)
      }
    })
  }
  animation = ''
  animation2 = ''
  animationTop = (h, isreset) => {
    var that = this
    var $rosterList1 = document.querySelector('.rosterList1');
    clearTimeout(that.timeer)
    clearTimeout(that.timeer2)
    if (isreset) {
      // that.animation
      //   .top('190rpx')
      //   .step({ duration: 0, timingFunction: 'step-start' })
      // that.animation2
      //   .top('190rpx')
      //   .step({ duration: 0, timingFunction: 'step-start' })
      // that.setData({
      //   animationData: that.animation.export(),
      //   animationData2: that.animation2.export()
      // })
      setTimeout(function () {
        that.animation
          .top({start: '1.9rem', end: '-' + (h / 100) + 'rem'})
          .step({ duration: 15000, timingFunction: 'linear' })
        $rosterList1.animate(that.animation.keyframes, that.animation.options);
        // that.setData({
        //   animationData: that.animation.export()
        // })
        that.animationTopCopy(h, isreset)
      }, 50)
    } else {
      that.timeer = setTimeout(function () {
        // that.animation
        //   .top('190rpx')
        //   .step({ duration: 0, timingFunction: 'step-start' })
        // that.setData({
        //   animationData: that.animation.export()
        // })
      }, (200 / (h + 200)) * 15000)
      that.timeer2 = setTimeout(function () {
        that.animation
          .top({start: '1.9rem', end: '-' + (h / 100) + 'rem'})
          .step({ duration: 15000, timingFunction: 'linear' })
        $rosterList1.animate(that.animation.keyframes, that.animation.options);
        // that.setData({
        //   animationData: that.animation.export()
        // })
        that.animationTopCopy(h)
      }, (h / (h + 200)) * 15000)
    }
  }
  animationTopCopy = (h, isreset) => {
    var that = this
    var $rosterList2 = document.querySelector('.rosterList2');
    clearTimeout(that.timeer3)
    clearTimeout(that.timeer4)
    // if (!isreset) {
      // that.timeer3 = setTimeout(function () {
        // that.animation2
        //   .top('190rpx')
        //   .step({ duration: 0, timingFunction: 'step-start' })
        // that.setData({
        //   animationData2: that.animation2.export()
        // })
      // }, (200 / (h + 200)) * 15000)
    // }
    that.timeer4 = setTimeout(function () {
      that.animation2
        .top({start: '1.9rem', end: '-' + (h / 100) + 'rem'})
        .step({ duration: 15000, timingFunction: 'linear' })
      $rosterList2.animate(that.animation2.keyframes, that.animation2.options);
      // that.setData({
      //   animationData2: that.animation2.export()
      // })
      that.animationTop(h)
    }, (h / (h + 200)) * 15000)
  }
  playMusics = () => {
    if (this.data.scratchInfo.bgm) {
      if (this.data.isPlay) {
        this.audioCtx.pause()
      } else {
        this.audioCtx.play()
      }
    } else {
      app.showToast({
        title: '活动未开始，没有音乐',
        icon: 'none'
      })
    }
  }
  audioPlay = () => {
    this.setData({
      isPlay: true
    })
  }
  audioPause = () => {
    this.setData({
      isPlay: false
    })
  }
  lookPrize = () => {
    let that = this
    if (that.data.scratchId) {
      that.setData({
        isPrizeSick: true,
        hideCanvas: true,
        isShowBtn: false,
        isRoll: false
      })
      that.getMyPrize()
    }
  }
  wrapPrize = () => {
    var that = this
    this.scratch.reset()
    this.setData({
      isPrizeSick: false,
      hideCanvas: false,
      isRoll: true
    })
    setTimeout(function () {
      that.setData({
        isShowBtn: true
      })
    }, 100)
  }
  stopPropagation = () => { }
  intelClick = () => {
    if (this.data.scratchId) {
      this.setData({
        isIntel: true,
        hideCanvas: true,
        isShowBtn: false
      })
      this.getMyIntegral()
    }
  }
  intelClose = () => {
    var that = this
    this.scratch.reset()
    this.setData({
      isIntel: false,
      hideCanvas: false,
      isFail: true, //显示未中奖
      isPrize: true, //显示中奖
      isComfort: true //显示安慰奖
    })
    setTimeout(function () {
      that.setData({
        isShowBtn: true
      })
    }, 50)
  }
  failBtnClick = () => {
    let that = this
    that.scratch.reset()
    that.setData({
      hideCanvas: false,
      isFail: true
    })
    setTimeout(function () {
      that.setData({
        isShowBtn: true
      })
    }, 100)
  }
  winningBtnClick = () => {
    let that = this
    that.scratch.reset()
    that.setData({
      hideCanvas: false,
      isPrize: true
    })
    setTimeout(function () {
      that.setData({
        isShowBtn: true
      })
    }, 100)
  }
  comfortBtnClick = () => {
    let that = this
    that.scratch.reset()
    that.setData({
      hideCanvas: false,
      isComfort: true,
      ifGetComfort: false
    })
    setTimeout(function () {
      that.setData({
        isShowBtn: true
      })
    }, 100)
  }
  bindReplaceInput = e => {
    this.setData({
      inputValue: e.target.value
    })
  }
  intelConfirm = () => {
    let that = this
    if (that.data.scratchId) {
      that.getIntegralTime()
    }
  }
  scratchInteAll = () => {
    let that = this
    that.setData({
      inputValue: that.data.intelMes.exchange_times
    })
  }
  getMyPrize = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getMyPrize',
      method: 'post',
      hideLoading: true,
      data: {
        activity_id: that.data.scratchId,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        that.setData({
          myPrize: res.data
        })
      }
    })
  }
  getMyIntegral = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getMyIntegralExchangeTimes',
      method: 'post',
      data: {
        activity_id: that.data.scratchId,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        that.setData({
          intelMes: res.data
        })
      }
    })
  }
  getIntegralTime = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getTime',
      method: 'post',
      data: {
        activity_id: that.data.scratchId,
        type: 'integral',
        times: that.data.inputValue,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        that.scratch.reset()
        that.setData({
          scratchTimes: res.data,
          isIntel: false,
          inputValue: '',
          hideCanvas: false,
          isDurMax: false,
          isDegree: false
        })
        setTimeout(function () {
          that.setData({
            isShowBtn: true
          })
        }, 200)
      }
    })
  }
  onShareAppMessage = res => {
    var that = this
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    return app.shareAppMessage({
      title: that.data.scratchInfo.title,
      path:
        '/awardManagement/pages/scratch/scratch?id=' +
        that.data.scratchId +
        '&shareKey=' +
        that.data.shareKey +
        franchiseeParam,
      success: function (res) { },
      fail: function (res) { }
    })
  }
  touchStart = () => { }
  touchEnd = () => { }
  touchMove = () => { }
  imgOnLoad = () => { }
  toAddCard = () => {
    let _data = this.data,
      wxcouponId = _data.ifWxCoupon,
      _this = this
    app.addCard({
      cardList: [
        {
          cardId: wxcouponId,
          cardExt:
            '{"nonce_str":"' +
            _data.timestamp +
            '","timestamp":"' +
            _data.timestamp +
            '", "signature":"' +
            _data.signature +
            '"}'
        }
      ],
      success: function (res) {
        _this.setData({
          ifWxCoupon: false
        })
        app.sendRequest({
          url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
          data: {
            card_id: res.cardList[0].cardId,
            sub_app_id: _data.franchisee,
            activity_id: _data.scratchInfo.id,
            app_id: _data.scratchInfo.app_id
          },
          success: function (res) {
            app.showModal({
              title: '提示',
              content: '领取卡券成功',
              showCancel: false
            })
            _this.setData({
              ifGetComfort: true
            })
            _this.getWinnerList(_this.data.scratchId)
          }
        })
      }
    })
  }
  shadeClose = el => {
    let _this = this,
      type = el.currentTarget.dataset.type
    app.showModal({
      title: '提示',
      content: '微信优惠券不领取到卡包，下次就不能再领取了哦，确定放弃优惠么？',
      showCancel: true,
      confirm: function (res) {
        _this.setData({
          ifWxCoupon: false,
          ifGetComfort: false
        })
        if (type == 1) {
          _this.winningBtnClick()
        } else if (type == 2) {
          _this.comfortBtnClick()
        }
      }
    })
  }

  render() {
    const {
      showGetUserInfo,
      topNavBarData,
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      scratchInfo,
      isPlay,
      scratchTimes,
      isFail,
      isPrize,
      scratchPrizeTitle,
      ifWxCoupon,
      isDurMax,
      isLimit,
      isComfort,
      ifGetComfort,
      isDegree,
      hideCanvas,
      scratch,
      isShowBtn,
      winnerList,
      animationData,
      animationData2,
      myPrize,
      isPrizeSick,
      intelMes,
      inputValue,
      isIntel
    } = this.state
    return (
      <div className="official-page scratch">
        <TopNav title="搜索"/>
        <div className="page scratch" id="scratch" >
          {/* TODO {scratchInfo.bgm != 0 && (
            <Audio
              className="bg-audio"
              id="scratchAudio"
              src={scratchInfo.bgm}
              onPlay={this.audioPlay}
              onPause={this.audioPause}
            ></Audio>
          )} */}
          <img
            className="scratch-cantaniner"
            src={
              scratchInfo.background ||
              'http://cdn.jisuapp.cn/static/webapp/images/scratchContainer.png'
            }
          />
          {scratchInfo.bgm != 0 && (
            <div
              className={'scratchMusic ' + (isPlay == true ? 'active' : '')}
              onClick={this.playMusics}
            >
              {isPlay == true && (
                <span className="ico-moon icon-luckyMusic"></span>
              )}
              {isPlay == false && (
                <span className="ico-moon icon-luckyMute"></span>
              )}
            </div>
          )}
          <div className="scratch-scater">
            <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchPonter.png" />
          </div>
          <div className="phoneCx">
            <div className="phone-todayChance">
              您今日还剩<span>{scratchTimes}</span>次刮奖机会
            </div>
            {scratchInfo.joined_show != -1 && (
              <div className="phone-personNum">
                ,共有<span>{scratchInfo.joined_show}</span>人参加活动
              </div>
            )}
          </div>
          <div className="scratchArea">
            <div className="scratchFail" hidden={isFail}>
              <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchFail.png" />
              <div className="failTitle">
                <div className="failShare" onClick={this.shareClickEvent}>分享</div>
                <div className="failText">很遗憾没有中奖哦</div>
                <div className="failBtn" onClick={this.failBtnClick}>
                  再来一次
                </div>
              </div>
            </div>
            {/*  中奖  */}
            <div className="scratchWinning" hidden={isPrize}>
              <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchPrize.png" />
              <div className="winningTitle">
                <div className="winningShare" onClick={this.shareClickEvent}>分享</div>
                <div className="winningText">恭喜你获得了</div>
                <div className="winningText winningValue">
                  {scratchPrizeTitle}
                </div>
                {ifWxCoupon ? (
                  <div className="btnGroup">
                    <div className="winningBtn" onClick={this.toAddCard}>
                      立即领取
                    </div>
                    <div
                      className="winningBtn"
                      onClick={this.shadeClose}
                      data-type="1"
                    >
                      再来一次
                    </div>
                  </div>
                ) : (
                    <div className="winningBtn" onClick={this.winningBtnClick}>
                      再来一次
                  </div>
                  )}
              </div>
            </div>
            {/*  次数不足，分享可获得次数  */}
            <div className="scratchDurMax" hidden={!isDurMax}>
              <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchLimit.png" />
              <div className="durMaxTitle">
                <div className="durMaxShare" onClick={this.shareClickEvent}>分享</div>
                <div className="durMaxText">对不起，您的刮奖次数不足，</div>
                <div className="durMaxText">分享即可获取次数哦~</div>
              </div>
            </div>
            {/*  次数已达到上限  */}
            <div className="scratchLimit" hidden={!isLimit}>
              <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchLimit.png" />
              <div className="limitTitle">
                <div className="limitShare" onClick={this.shareClickEvent}>分享</div>
                <div className="limitText">今日刮奖次数已达到上限，</div>
                <div className="limitText">明日可继续参与刮奖哦~</div>
              </div>
            </div>
            {/*  安慰奖  */}
            <div className="scratchComfort" hidden={isComfort}>
              <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchComfort.png" />
              <div className="comfortTitle">
                <div className="comfortShare" onClick={this.shareClickEvent}>分享</div>
                {ifGetComfort ? (
                  <div className="comfortText">
                    已领取，在微信卡包中查看哦~
                  </div>
                ) : (
                    <div className="comfortText" className="comfortText">
                      又没中奖，送你一个小礼品
                  </div>
                  )}
                {ifWxCoupon ? (
                  <div className="btnGroup">
                    <div className="comfortBtn" onClick={this.toAddCard}>
                      立即领取
                    </div>
                    <div
                      className="comfortBtn"
                      onClick={this.shadeClose}
                      data-type="2"
                    >
                      知道了
                    </div>
                  </div>
                ) : (
                    <React.Fragment>
                      {!ifGetComfort && (
                        <div className="comfortText">
                          在优惠券卡包进行查收哦~
                      </div>
                      )}
                      <div className="comfortBtn" onClick={this.comfortBtnClick}>
                        知道了
                    </div>
                    </React.Fragment>
                  )}
              </div>
            </div>
            {/*  次数不足，不可分享  */}
            <div className="scratchDegree" hidden={!isDegree}>
              <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchLimit.png" />
              <div className="degreeTitle">
                <div className="degreeText">对不起，您的刮奖次数不足</div>
              </div>
            </div>
            <div
              hidden={hideCanvas}
              className="scratch_wp"
              style={convertLineStyleData(
                'width: ' +
                (scratch && scratch.width) +
                'px; height: ' +
                (scratch && scratch.height) +
                'px;'
              )}
            >
              <div hidden={isShowBtn}>
                <canvas
                  className="scratch-canvas"
                  width={scratch && scratch.width}
                  height={scratch && scratch.height}
                  id="scratch-canvas"
                  onTouchStart={this.touchStart}
                  onTouchMove={this.touchMove}
                  onTouchEnd={this.touchEnd}
                ></canvas>
              </div>
              {isShowBtn && (
                <div className="showArea">
                  <div className="showTitle">赢取优惠大奖</div>
                  <div className="showBtn" onClick={this.startScratch}>
                    点我刮奖
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="structurePrize">
            <div className="scratch-lookPrize" onClick={this.lookPrize}>
              查看奖品
            </div>
            <div
              className="scratch-exchangePrize"
              onClick={this.intelClick}
              style={convertLineStyleData(
                'display:' +
                (scratchInfo.integral_exchange == 0 ? 'none' : 'inline-block')
              )}
            >
              积分兑换
            </div>
          </div>
          <div className="scratchRoster">
            <div className="rosterTitle">
              <div className="rosterStar"></div>
            </div>
            <div className="rosterCon">
              {winnerList.length === 0 ? (
                <div className="no-roster-list">暂无中奖名单</div>
              ) : (
                  <React.Fragment>
                    <div className="rosterList rosterList1" animation={animationData}>
                      {winnerList.map((item, index) => {
                        return (
                          <div key={index}>
                            {item.nickname + ' 抽中 ' + item.prize_title}
                          </div>
                        )
                      })}
                    </div>
                    <div className="rosterList rosterList2" animation={animationData2}>
                      {winnerList.map((item, index) => {
                        return (
                          <div key={index}>
                            {item.nickname + ' 抽中 ' + item.prize_title}
                          </div>
                        )
                      })}
                    </div>
                  </React.Fragment>
                )}
            </div>
          </div>
          <div className="scratchExplain">
            <div className="explainTitle">
              <div className="explainStar"></div>
            </div>
            <div className="explainCon">
              <div className="explainTimeDiv">
                <span>活动时间：</span>
                <span className="explainTime">
                  {scratchInfo.start_time}-{scratchInfo.end_time}
                </span>
              </div>
              <div className="explainRule">
                <span>{scratchInfo.description}</span>
              </div>
              <div>获取刮奖次数：</div>
              {scratchInfo.user_times_initial > 0 && (
                <div className="explainDayTime">
                  <label className="scratchDisc">·</label>用户每日首次登录可获取
                  <span>{scratchInfo.user_times_initial}</span>次刮奖机会
                </div>
              )}
              <div className="explainLimit">
                <label className="scratchDisc">·</label>每日抽奖机会最多为
                <span className="explainValue">
                  {scratchInfo.user_times == '-1'
                    ? '无限'
                    : scratchInfo.user_times}
                </span>
                次
              </div>
              {scratchInfo.integral_exchange != 0 && (
                <div className="explainIntegral">
                  <label className="scratchDisc">·</label>每
                  <span>{scratchInfo.integral_exchange}</span>
                  积分可兑换一次抽奖机会
                </div>
              )}
              {scratchInfo.time_share != 0 && (
                <div className="explainShare">
                  <label className="scratchDisc">·</label>
                  <div>
                    每成功分享1个好友可增加<span>{scratchInfo.time_share}</span>
                    次抽奖机会，最多可增加
                    <span>{scratchInfo.time_share_limit}</span>次机会
                  </div>
                </div>
              )}
              {scratchInfo.consume_times != 0 && (
                <div className="explainMoney">
                  <label className="scratchDisc">·</label>
                  消费即赠送一次刮奖机会。
                </div>
              )}
            </div>
          </div>
          {/*  中奖记录弹窗  */}
          {isPrizeSick == true && (
            <div className="scratchPrize-sick" onClick={this.wrapPrize}>
              <div className="scratchPrize-bg" ></div>
              <div
                className="scratchPrize-wrap"
                onClick={this.stopPropagation}
              >
                <div className="scratchPrize-header" ></div>
                <div className="scratchPrize-con">
                  <img
                    className="scratchImg"
                    src="http://cdn.jisuapp.cn/static/webapp/images/prize_con.png"
                    hidden={myPrize == ''}
                    
                  />
                  <div className="scratchPrize-title" >
                    <div className="scratchPrize-line"></div>
                    <label>中奖时间</label>
                    <label>获得奖品</label>
                  </div>
                  <div className="scratchprize-list" hidden={myPrize == ''}>
                    {myPrize.map((item, index) => {
                      return (
                        <div key={index}>
                          <label>{item.add_time}</label>
                          <label>{item.prize_title}</label>
                        </div>
                      )
                    })}
                  </div>
                  <div className="scratchPrize-fail" hidden={myPrize != ''}>
                    <img src="http://cdn.jisuapp.cn/static/webapp/images/prize_fail.png" />
                    <div>暂未获得任何奖品哦~</div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/*  积分兑换弹窗  */}
          {isIntel == true && (
            <div className="scratchInte">
              <div className="scratchInte-wrap">
                <div className="scratchInte-con">
                  <div className="scratchInteCan">
                    可兑换次数:<label>{intelMes.exchange_times}</label>
                    <label>次</label>
                  </div>
                  <div className="scratchInteLimit">
                    兑换次数:
                    <input
                      type="text"
                      onChange={this.bindReplaceInput}
                      value={inputValue}
                    />
                    <label
                      className="scratchInteAll"
                      onClick={this.scratchInteAll}
                    >
                      全部兑换
                    </label>
                  </div>
                  <div className="scratchInteRule">
                    兑换规则:<label>{intelMes.integral_exchange}</label>分/次
                  </div>
                  <div className="scratchInteBalance">
                    积分余额:<label>{intelMes.can_use_integral}</label>分
                  </div>
                </div>
                <div className="scratchInte-btns">
                  <div
                    className="scratchInte-cancel"
                    onClick={this.intelClose}
                  >
                    取消
                  </div>
                  <div
                    className="scratchInte-confirm"
                    onClick={this.intelConfirm}
                  >
                    确定
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/scratch/Scratch.jsx